import * as s from "styles/ModalCommonStyled";
import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import { ModalInput } from "components/atoms/input/modal/ModalInput";
import Input from "components/atoms/input/Input";
import BigButton from "components/atoms/buttons/BigButton";
import * as button from "components/atoms/buttons/ButtonStyled";

import { ValidateWord } from "components/atoms/text/Text";
import SelectComponent from "components/atoms/select/SelectComponent";
import { HiUpload } from "react-icons/hi";
import Spinner from "components/atoms/loader/Spinner";
import { VideoGuidePdfDto } from "api/interfaces/managerInterface.interface";
import {
  Validate,
  ValidateMsg,
} from "api/interfaces/commonInterface.interface";
import { UPDATE_TYPE } from "./AddPdfContainer";
import { videoGuideOptions, type Option } from "utils/options";
import { COLORS } from "styles/colors";

interface Props {
  isEdit: boolean;
  onModal: () => void;
  pdfItemInfo: VideoGuidePdfDto;
  validate: Validate;
  validateMsg: ValidateMsg;
  isInProcess: boolean;
  onChangeUserInfo: (type: UPDATE_TYPE, value: string) => void;
  onSaveBefore: () => void;
  maxPosition: number;
  groupOptions: Option[];
  groupOptionsIsFetching: boolean;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function AddPdfPresenter(props: Props) {
  return (
    <BigPopupTemplate
      title={props.isEdit ? "Edit File" : "Add File"}
      onModal={props.onModal}
    >
      <s.Row>
        <ModalInput label="Category" essential half>
          <SelectComponent
            options={videoGuideOptions}
            value={videoGuideOptions[0]?.value}
            disabled={true}
          />
        </ModalInput>
        <ModalInput label="Group" essential half>
          <SelectComponent
            options={props.groupOptions}
            loading={props.groupOptionsIsFetching}
            value={
              props.pdfItemInfo.groupId === ""
                ? props.groupOptions[0]?.value
                : props.pdfItemInfo.groupId
            }
            disabled={props.isInProcess}
            onChange={(value) => {
              props.onChangeUserInfo(UPDATE_TYPE.GROUP, value);
            }}
            data-testid="manager-video-manager-pdf-select-change-user-info"
          />
        </ModalInput>
      </s.Row>
      <s.Row>
        <ModalInput label="Title" essential>
          <Input
            value={props.pdfItemInfo.title}
            placeholder="Enter a title for File."
            onChange={(e) => {
              props.onChangeUserInfo(UPDATE_TYPE.TITLE, e.target.value);
            }}
            isValidated={props.validate.title}
            disabled={props.isInProcess}
            data-testid="manager-video-manager-pdf-input-change-user-info"
          />

          <ValidateWord data-testid="manager-video-manager-pdf-validate-title">
            {props.validateMsg.title}
          </ValidateWord>
        </ModalInput>
      </s.Row>

      <s.Row>
        <ModalInput label="File" half essential>
          <input
            type="file"
            id="fileUpload"
            style={{ display: "none" }}
            onChange={props.handleFileChange}
            disabled={props.isInProcess}
            data-testid="manager-video-manager-pdf-file-upload-file-change"
          />

          <button.Container
            buttonType="cancel"
            style={{
              width: "100%",
              padding: "10px 16px",
              fontSize: 14,
            }}
            onClick={() => document.getElementById("fileUpload")?.click()}
            disabled={props.isInProcess}
            data-testid="manager-video-manager-pdf-container-get-element-by-id"
          >
            <HiUpload />
            {props.pdfItemInfo.fileName
              ? `${props.pdfItemInfo.fileName.substring(0, 20)}${
                  props.pdfItemInfo.fileName.length > 20 ? "..." : ""
                }`
              : "Upload from PC"}
          </button.Container>
          <ValidateWord data-testid="manager-video-manager-pdf-validate-file">
            {props.validateMsg.file}
          </ValidateWord>
        </ModalInput>
        <ModalInput label="Order" half>
          <Input
            type="number"
            min={1}
            value={props.pdfItemInfo.position}
            placeholder="Enter a order for this guide."
            onChange={(e) => {
              props.onChangeUserInfo(UPDATE_TYPE.ORDER, e.target.value);
            }}
            disabled={props.isInProcess}
            max={props.maxPosition}
            data-testid="manager-video-manager-pdf-input-change-user-info-2"
          />
        </ModalInput>
      </s.Row>
      <ModalInput label="Description">
        <Input
          value={props.pdfItemInfo.description}
          placeholder="Please enter a description"
          onChange={(e) => {
            props.onChangeUserInfo(UPDATE_TYPE.DESC, e.target.value);
          }}
          disabled={props.isInProcess}
          data-testid="manager-video-manager-pdf-input-change-user-info-3"
        />
      </ModalInput>
      <SaveBtn
        onSaveBefore={props.onSaveBefore}
        isInProcess={props.isInProcess}
      />
    </BigPopupTemplate>
  );
}

type SaveBtnType = {
  onSaveBefore: () => void;
  isInProcess: boolean;
};
const SaveBtn = ({ onSaveBefore, isInProcess }: SaveBtnType) => {
  if (isInProcess) {
    return (
      <s.ButtonWrapper>
        <Spinner size={8} inline={true} />
      </s.ButtonWrapper>
    );
  }
  return (
    <s.ButtonWrapper>
      <BigButton
        label="Save"
        onClickBtn={onSaveBefore}
        disabled={isInProcess}
        data-testid="manager-video-manager-pdf-button-save-before"
      />
    </s.ButtonWrapper>
  );
};
